module.exports = __webpack_public_path__ + "img/h-sc1.f89b9763.png";